<template>
    <Frame>
    <PageHeader :title="$t('comm.quotationSearch')" :hasBack="false" />
    <div class="QuotationHeader">
        <div class="delivermessage">
          <span class="detailmessage">
            <span class="boxlabel">{{ $t('ReturnQuery.billDate') }}：</span>
            <el-date-picker v-model="billdate" type="daterange" style="min-width: 215px; color:#bbbbbb;" range-separator="~"
              @change="getTime()" :start-placeholder="$t('comm.startdate')" :end-placeholder="$t('comm.enddate')"
              :unlink-panels="true" size="small">
            </el-date-picker></span>
          <span class="detailmessage">
            <span class="boxlabel">{{ $t('ReturnQuery.billNo') }}：</span><el-input
              :placeholder="$t('ReturnQuery.inputpls')" v-model="BillNo" clearable style="color:#bbbbbb;"
              @change="inputchange()" size="small"></el-input></span>
          <span class="detailmessage" v-if="$store.state.ShowComp">
            <span class="boxlabel">{{ $t('ReturnQuery.orgName') }}：</span><el-input
              :placeholder="$t('ReturnQuery.inputpls')" v-model="FOrgName" clearable style="color:#bbbbbb;"
              @change="inputchange()" size="small"></el-input></span>
            <span class="detailmessage">
                <span class="boxlabel">{{ $t('Quotation.quotationDeadline') }}：</span>
                <el-date-picker v-model="QuoteDdlDateValue" type="daterange" style="min-width: 215px; color:#bbbbbb;" range-separator="~"
              @change="getEndTime()" :start-placeholder="$t('comm.startdate')" :end-placeholder="$t('comm.enddate')"
              :unlink-panels="true" size="small">
                </el-date-picker>
            </span>
            <span class="detailmessage">
                <span class="boxlabel">{{ $t('Quotation.IsWholeOrderQuote') }}：</span>
                <el-checkbox v-model="WholeOrderQuote" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('comm.btnyes') }}</span>
                <el-checkbox v-model="NotWholeOrderQuote" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('comm.btnno') }}</span>
            </span>
            <span class="detailmessage">
                <span class="boxlabel">{{ $t('Quotation.IsPriceWithTax') }}：</span>
                <el-checkbox v-model="WithTax" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('comm.btnyes') }}</span>
                <el-checkbox v-model="NotWithTax" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('comm.btnno') }}</span>
            </span>
            <span class="detailmessage">
                <span class="boxlabel">{{ $t('Quotation.purChaseType') }}：</span>
                <el-checkbox v-model="productPurchase" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('Quotation.productPurchase') }}</span>
                <el-checkbox v-model="subcontract" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('Quotation.subcontract') }}</span>
            </span>
            <span class="detailmessage">
                <span class="boxlabel">{{ $t('Quotation.quotationState') }}：</span>
                <el-checkbox v-model="noQuotation" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('Quotation.noQuotation') }}</span>
                <el-checkbox v-model="partQuotation" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('Quotation.partQuotation') }}</span>
                <el-checkbox v-model="allQuotation" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('Quotation.allQuotation') }}</span>
            </span>
            <span class="detailmessage">
                <span class="boxlabel">{{ $t('Quotation.endQuotationTip') }}：</span>
                <el-checkbox v-model="EndQuotation" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('comm.btnyes') }}</span>
                <el-checkbox v-model="NotEndQuotation" @change="inputchange" class="checkBox"></el-checkbox><span class="boxlabel checkboxlabel">{{ $t('comm.btnno') }}</span>
            </span>
        </div>
        <div style="width: 100%;display: block;">
          <span style="float: right; padding-right:20px;padding-bottom:20px;">
            <el-button type="reset" @click="reset()">{{ $t('button.reset') }}</el-button>
            <el-button type="primary" @click="getQuotation(0)">{{ $t('button.query') }}</el-button>
          </span>
        </div>
    </div>
    <div class="QuotationBody">
        <el-table ref="multipleTable" :data="tableData" :height="tableHeight" style="margin:0;width:100%"
          tooltip-effect="dark" v-loading="tableLoading">
        <el-table-column prop="BizAttr" :label="$t('Quotation.purChaseType')" :min-width="100">
            <template slot-scope="scope">
                <span v-if="scope.row.BizAttr == '100'">
              <span>{{ $t('Quotation.productPurchase') }}</span>
            </span>
            <span  v-else-if="scope.row.BizAttr == '180'">
              <span>{{ $t('Quotation.subcontract') }}</span>
            </span> 
            </template>
        </el-table-column>
        <el-table-column prop="BillDate" :label="$t('ReturnQuery.billDate')" :min-width="WidthControl('BillDate',tableData)"></el-table-column>
        <el-table-column prop="BillNo" :label="$t('Order.messagenumber')" :min-width="WidthControl('BillNo',tableData)">
            <template slot-scope="scope">
                <el-link :underline="false"  @click="check(scope.row)">{{ scope.row.BillNo }}</el-link>
            </template>
        </el-table-column>
        <el-table-column prop="FOrgName" :label="$t('ReturnQuery.orgName')" v-if="$store.state.ShowComp" :min-width="WidthControl('FOrgName',tableData)"></el-table-column>
        <el-table-column prop="ValidityToDate" :label="$t('Quotation.inquiryDeadline')" :min-width="WidthControl('ValidityToDate',tableData)"></el-table-column>
        <el-table-column prop="QuoteDdlDate" :label="$t('Quotation.quotationDeadline')" :min-width="WidthControl('QuoteDdlDate',tableData)"></el-table-column>
        <el-table-column prop="QuoteState" :label="$t('Quotation.quotationState')" :min-width="100">
            <template slot-scope="scope">
                <span style="display: flex;" v-if="scope.row.QuoteState == 0">
                    <div class="dot graydot"></div>
              <span>{{ $t('Quotation.noQuotation') }}</span>
            </span>
            <span style="display: flex;" v-else-if="scope.row.QuoteState == 1">
                <div class="dot bluedot"></div>
              <span>{{ $t('Quotation.partQuotation') }}</span>
            </span>
            <span style="display: flex;" v-else-if="scope.row.QuoteState == 2">
                <div class="dot graydot"></div>
              <span>{{ $t('Quotation.allQuotation') }}</span>
            </span>
            </template>
        </el-table-column>
        <el-table-column prop="IsEndInquiry" :label="$t('Quotation.endQuotationTip')" :min-width="100">
            <template slot-scope="scope">
                <span v-if="scope.row.IsEndInquiry">
              <span>{{ $t('comm.btnyes') }}</span>
            </span>
            <span v-else>
              <span>{{  $t('comm.btnno') }}</span>
            </span> 
            </template>
        </el-table-column>
        <el-table-column width="120" :label="$t('Order.operation')">
            <template slot-scope="scope">
                <el-button class="topbutton" size="mini" type="text" @click="check(scope.row,true)">{{ $t('Quotation.inquiry') }}</el-button>
                <el-button class="topbutton" size="mini" type="text" @click="check(scope.row)">{{ $t('Quotation.view') }}</el-button>
            </template>
        </el-table-column>
        </el-table>
    </div>
   
        <div class="QuotationFooter">
            <PageSizeChanger  :pagesize.sync="pagesize"  :afterChange="pageSizeChange"></PageSizeChanger>
          <el-pagination style="width:40%;margin-top:5px;" @current-change="handleCurrentChange" ref="pageination"
            layout="total,prev,pager,next,jumper" :pager-count="5" :current-page.sync="currentPage" :total="totalCount" :page-size="$store.state.pagesize">
          </el-pagination>
        </div>
    </Frame>
</template>
<script>
  import PageSizeChanger from '@/components/PageSizeChanger.vue'
  import { handleShortDate } from '../utils/handleDate.js'
    export default{
        components:{
            PageSizeChanger
        },
        data(){
            return{
                billdate:null,
                BillNo:'',
                FOrgName:'',
                productPurchase:true,
                subcontract:true,
                QuoteDdlDateValue:null,
                QuoteStartdate:'',
                QuoteEnddate:'',
                noQuotation:true,
                partQuotation:true,
                allQuotation:false,
                tableLoading:false,
                tableData:[],
                tableHeight:window.innerHeight - 415,
                currentPage:1,
                totalCount:0,
                pagesize: this.$store.state.pagesize,
                pageindex:0,
                startdate:'',
                enddate:'',
                WholeOrderQuote:true,
                NotWholeOrderQuote:true,
                WithTax:true,
                NotWithTax:true,
                EndQuotation:false,
                NotEndQuotation:true,
                
            }
        },
        watch:{
            WithTax:{
                handler:function(newval,oldval){
                    var taxlist = {withTax:this.WithTax,withoutTax:this.NotWithTax};
                    localStorage.setItem("iswithtaxRecord",JSON.stringify(taxlist));
                }
            },
            NotWithTax:{
                handler:function(newval,oldval){
                    var taxlist = {withTax:this.WithTax,withoutTax:this.NotWithTax};
                    localStorage.setItem("iswithtaxRecord",JSON.stringify(taxlist));
                }
            }
        },
        created(){
            if(localStorage.getItem("iswithtaxRecord")){
                var iswithtaxRecord = JSON.parse(localStorage.getItem("iswithtaxRecord"));
                this.WithTax = Boolean(iswithtaxRecord.withTax);
                this.NotWithTax = Boolean(iswithtaxRecord.withoutTax);  
            }
            if (sessionStorage.getItem("QuotationDetail") && sessionStorage.getItem("QuotationDetail") != "null") {
                var history = JSON.parse(sessionStorage.getItem("QuotationDetail"));
                this.billdate = history.billdate;
                this.BillNo = history.BillNo;
                this.FOrgName = history.FOrgName;
                this.productPurchase = history.productPurchase;
                this.subcontract = history.subcontract;
                this.QuoteEnddate = history.QuoteEnddate;
                this.QuoteStartdate = history.QuoteStartdate;
                this.QuoteDdlDateValue = history.QuoteDdlDateValue;
                this.noQuotation = history.noQuotation;
                this.partQuotation = history.partQuotation;
                this.allQuotation = history.allQuotation;
                this.currentPage = history.currentPage;
                this.pageindex = history.pageindex;
                this.startdate = history.startdate;
                this.enddate = history.enddate;
                this.WithTax = history.WithTax;
                this.NotWithTax = history.NotWithTax;
                this.WholeOrderQuote = history.WholeOrderQuote;
                this.NotWholeOrderQuote = history.NotWholeOrderQuote;
                this.EndQuotation = history.EndQuotation;
                this.NotEndQuotation = history.NotEndQuotation;
                sessionStorage.removeItem("QuotationDetail");
                this.getQuotation(this.pageindex);
            }else{
                this.getQuotation(0);
            }
        },
        mounted(){
            window.onresize = () => {
                this.tableHeight=window.innerHeight - 415;
            }
            
        },
        methods:{
            getQuotation(pageindex){
                this.tableLoading = true;
                this.pageindex = pageindex;
                this.currentPage = pageindex+1;
            this.axiosInvoke(this.sysHandlerUrl,
                {
                    action:'getpurinquirydemand',
                    BillNo:this.BillNo,
                    startdate:this.startdate,
                    enddate:this.enddate,
                    FOrgName:this.FOrgName,
                    QuoteStartdate:this.QuoteStartdate,
                    QuoteEnddate:this.QuoteEnddate,
                    WholeOrderQuote:this.WholeOrderQuote,
                    NotWholeOrderQuote:this.NotWholeOrderQuote,
                    EndQuotation:this.EndQuotation,
                    NotEndQuotation:this.NotEndQuotation,
                    NotWithTax:this.NotWithTax,
                    WithTax:this.WithTax,
                    productPurchase:this.productPurchase,
                    subcontract:this.subcontract,
                    noQuotation:this.noQuotation,
                    partQuotation:this.partQuotation,
                    allQuotation:this.allQuotation,
                    pageindex:this.pageindex,
                    pagesize:this.pagesize,
                },(res,err)=>{
                    if(err){
                        this.tableLoading = false;
                        return;
                    }
                    this.tableLoading = false;
                    this.totalCount = res.data.totalCount;
                    this.tableData = res.data.TableData; 
                });
            },
            inputchange(){
                this.getQuotation(0);
            },
            pageSizeChange(){
                this.getQuotation(0);  
            },
            handleCurrentChange(val) {
                //翻页时触发的方法
                this.pageindex = val - 1;
                this.getQuotation(val - 1);
            },
            //获取时间
            getTime() {
                if(this.billdate){
                this.startdate = handleShortDate(this.billdate[0], "From");
                this.enddate = handleShortDate(this.billdate[1], "To");
                }
                else{
                this.startdate = "";
                this.enddate = "";
                }
                this.getQuotation(0);
            },
            getEndTime(){
                if(this.QuoteDdlDateValue){
                    this.QuoteStartdate = handleShortDate(this.QuoteDdlDateValue[0], "From");
                    this.QuoteEnddate = handleShortDate(this.QuoteDdlDateValue[1], "To");
                }
                else{
                    this.QuoteStartdate = "";
                    this.QuoteEnddate = "";
                }
                this.getQuotation(0);
            },
            reset(){
                this.billdate = null,
                this.BillNo='',
                this.FOrgName='',
                this.productPurchase=true,
                this.subcontract=true,
                this.QuoteDdlDateValue=null,
                this.QuoteStartdate='',
                this.QuoteEnddate='',
                this.noQuotation=true,
                this.partQuotation=true,
                this.allQuotation=false,
                this.currentPage=1,
                this.pageindex=0,
                this.startdate='',
                this.enddate='',
                this.getQuotation(0);
                this.WholeOrderQuote = true;
                this.NotWholeOrderQuote = true;
                this.EndQuotation = false;
                this.NoEndQuotation = true;
            },
            check(scope,edit) {//查看
                sessionStorage.setItem("Quotation", JSON.stringify({
                    billdate:this.billdate,
                    BillNo:this.BillNo,
                    FOrgName:this.FOrgName,
                    productPurchase:this.productPurchase,
                    subcontract:this.subcontract,
                    QuoteEnddate:this.QuoteEnddate,
                    QuoteStartdate:this.QuoteStartdate,
                    QuoteDdlDateValue:this.QuoteDdlDateValue,
                    noQuotation:this.noQuotation,
                    partQuotation:this.partQuotation,
                    allQuotation:this.allQuotation,
                    currentPage:this.currentPage,
                    pageindex:this.pageindex,
                    startdate:this.startdate,
                    enddate:this.enddate,
                    WithTax:this.WithTax,
                    NotWithTax:this.NotWithTax,
                    WholeOrderQuote:this.WholeOrderQuote,
                    NotWholeOrderQuote:this.NotWholeOrderQuote,
                    EndQuotation:this.EndQuotation,
                    NotEndQuotation:this.NotEndQuotation
                }))
                let routerQuery = {
                    BillNo: scope.BillNo,
                    }
                if(edit){
                    routerQuery.edit = true;
                }
                this.$router.push({
                    path: "/Home/QuotationDetail",
                    query: routerQuery
                })
            },
        }
    }
</script>
<style scoped>
.QuotationHeader{
    padding:10px 0 0;
}
.QuotationBody{
    width: 100%;
}
.QuotationFooter{
    padding-top: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
}
.delivermessage {
    padding: 10px 20px;
    display: flex;
    flex-wrap: wrap;
    width: 85%;
  }
.detailmessage {
    display: flex;
    white-space: nowrap;
    flex-wrap: nowrap;
    color: #5d5d5d;
    font-size: 14px;
    width: 30%;
    padding: 0 10px 15px 10px;
  }
.checkBox{
    margin: auto 0;
}
.boxlabel{
    margin: auto 0;
}
.checkboxlabel{
    padding:0 20px 0 10px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
}
.el-table /deep/ thead {
    font-size: 14px;
    color: #5d5d5d;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f9f9f9;
}
.el-table /deep/ .el-table__body-wrapper {
    font-size: 13px;
  }
.topbutton {
    color: #0177d5;
    font-size: 14px;
}
.dot{
    width: 5px;
    height: 5px;
    border-radius: 3px;
    margin: auto 7px auto 0;
}
.graydot{
    background-color: rgb(182, 182, 182);
}
.bluedot{
    background-color: rgb(40, 158, 255);
}

@media screen and (max-width:1500px)  {
    .detailmessage{
        width: 30%;
    }
    .delivermessage{
        width: calc( 100% - 40px );
    }
}
</style>

